import { BulletinItem } from '../../../components/bulletins/bulletinList/BulletinList';
import Bulletins from 'src/components/bulletins/Bulletins';
import { BulletinsService } from '../../../services/bulletins.service';
import ContactInfo from 'src/components/contactInfo/ContactInfo';
import { CreditAppService } from 'src/services/credit-app.service';
import CriticalNotifications from 'src/components/ui/criticalNotification/CriticalNotifications';
import DealerHeader from 'src/components/header/DealerHeader';
import FooterPrivacy from '../../auth/components/baseTemplate/FooterPrivacy';
import { FundingService } from '../../../services/funding.service';
import { getBrandByDealerNumber } from 'src/utils/helpers';
import Handbook from 'src/components/handbook/Handbook';
import { IUser } from '../../../utils/interfaces/user';
import StatusSummary from 'src/components/statusSummary/StatusSummary';
import { useLocalization } from 'src/utils/useLocalization';
import { useSelector } from 'react-redux';
import React, { useEffect, useState } from 'react';
import './styles.scss';

interface IStatusDataset {
    approved: number;
    pending: number;
    declined: number;
    conditioned: number;
    withdrawn: number;
}

interface IDealerDataSet {
    dealerName: string;
    address: string;
}

interface IDealerDataAdmin {
    name: string;
    phone: string;
    email: string;
    fax: string;
}

// The bulletins API expects 'VW' in caps and the other brands capitalized.
const getBulletinBrand = (brand: string) => {
    if (brand === 'vw') return brand.toUpperCase();
    const [first = '', ...rest] = brand;
    return first.toUpperCase() + rest.join('');
};

const Application = () => {
    const { currentDealers, dealerDataInfo, accessUser } = useSelector(
        (state: IUser) => {
            return state;
        },
    );
    const { labelText } = useLocalization();
    const fundingService = new FundingService();
    const creditService = new CreditAppService();
    const bulletinService = new BulletinsService();

    const [fundingDataset, setFundingDataset] = useState<IStatusDataset>({
        approved: 0,
        pending: 0,
        conditioned: 0,
        declined: 0,
        withdrawn: 0,
    });
    const [creditDataset, setCreditDataset] = useState<IStatusDataset>({
        approved: 0,
        pending: 0,
        declined: 0,
        conditioned: 0,
        withdrawn: 0,
    });
    const [bulletinDataset, setBulletinDataSet] = useState<
        Array<BulletinItem> | undefined
    >(undefined);
    const [brand, setBrand] = useState<string>('vw6');
    const [dealerDataset, setDealerDataset] = useState<IDealerDataSet>({
        dealerName: '',
        address: '',
    });
    const [admin, setAdmin] = useState<IDealerDataAdmin | undefined>(undefined);
    async function fundingStatusRequest() {
        const res = await fundingService.fundingStatusWidget(
            currentDealers?.default as string,
        );
        if (res && res.data) {
            setFundingDataset(res.data);
        }
    }
    async function creditStatusRequest() {
        const res = await creditService.creditStatusWidget(
            currentDealers?.default as string,
        );
        if (res && res.data) {
            setCreditDataset(res.data);
        }
    }
    async function bulletinListRequest() {
        if (dealerDataInfo) {
            const { dealer } = dealerDataInfo;
            const res = await bulletinService.getBulletinList(
                currentDealers?.default as string,
                getBulletinBrand(
                    getBrandByDealerNumber(dealer.brand, dealer.dealerNumber),
                ),
                dealer.stateProvince,
                dealer.district.districtCode,
                dealer.region.regionCode,
            );
            if (res && res.data) {
                setBulletinDataSet(res.data);
            } else setBulletinDataSet([]);
        } else setBulletinDataSet([]);
    }
    useEffect(() => {
        if (currentDealers && dealerDataInfo) {
            fundingStatusRequest();
            creditStatusRequest();
            const { dealer, dealerContacts } = dealerDataInfo;
            bulletinListRequest();
            setBrand(getBrandByDealerNumber(dealer.brand, dealer.dealerNumber));
            setDealerDataset({
                address: dealer.addressLine1,
                dealerName: dealer.dealerName,
            });
            if (dealerContacts.length) {
                const contact = dealerContacts[0];
                setAdmin({
                    email: contact.email,
                    fax: contact.fax || '',
                    name: `${contact.firstName || ''} ${contact.lastName}`,
                    phone: contact.phone || '',
                });
            }
        }
        return () => {
            fundingService.abort();
            creditService.abort();
            bulletinService.abort();
        };
    }, [dealerDataInfo]);
    if (
        accessUser &&
        (currentDealers?.default === undefined ||
            currentDealers?.default === 'null' ||
            currentDealers?.default === '')
    )
        return (
            <>
                <div className='field-user-empty'>
                    <div className='field-user-empty__title'>
                        {labelText.LABEL_TEXT_DASH_MAIN_ACC}
                    </div>
                    <div className='field-user-empty__text u-mt-small'>
                        {labelText.LABEL_TEXT_DASH_SEC_ACC}
                    </div>
                </div>
                <div className='u-ml-small'>
                    <FooterPrivacy />
                </div>
            </>
        );
    return (
        <div className='wrapper'>
            <div className='box0'>
                <CriticalNotifications />
            </div>
            <div className='box1'>
                <DealerHeader brand={brand} dealerDataset={dealerDataset} />
            </div>
            <div className='box2'>
                <Bulletins bulletinsDataset={bulletinDataset} />
            </div>
            <div className='box3'>
                <StatusSummary
                    creditDataset={creditDataset}
                    fundingDataset={fundingDataset}
                    brand={brand}
                />
            </div>
            <div className='box4'>
                <ContactInfo admin={admin} brand={brand} />
            </div>
            <div className='box5'>
                <Handbook brand={brand} />
            </div>
            <div className='box6'>
                <FooterPrivacy />
            </div>
        </div>
    );
};

export default Application;
